module.exports = __webpack_public_path__ + "img/nextVideo.561a497a.svg";